// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/settings.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

a {
  text-decoration: none;
}

p {
  font-size: 1rem;
}
@media (min-width: 768px) {
  p {
    font-size: 2rem;
  }
}

h2 {
  font-size: 1.5rem;
}
@media (min-width: 768px) {
  h2 {
    font-size: 3rem;
  }
}

h3 {
  font-size: 1.25rem;
}
@media (min-width: 768px) {
  h3 {
    font-size: 2rem;
  }
}

.navbar {
  background-color: rgb(240, 217, 181);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  list-style-type: none;
  margin: 0;
  height: 3rem;
  padding: 0 1rem;
}
@media (min-width: 768px) {
  .navbar {
    padding: 0 2.25rem;
    height: 5rem;
  }
}
@media (min-width: 1280px) {
  .navbar {
    padding: 0 calc(25rem + (100vw - 1280px) / 2);
  }
}
.navbar__title {
  margin-right: auto;
  margin-left: auto;
}
.navbar__settings {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  width: 1rem;
  height: 1rem;
  background-repeat: no-repeat;
  background-size: cover;
  border: none;
  outline: none;
  background-color: rgba(0, 0, 0, 0);
}
@media (min-width: 768px) {
  .navbar__settings {
    width: 2.5rem;
    height: 2.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/_partials.scss","webpack://./src/components/Header/Header.scss"],"names":[],"mappings":"AAiBA;EACE,sBAAA;AChBF;;AD8BA;EACE,qBAAA;AC3BF;;AD6BA;EACE,eAAA;AC1BF;ADJE;EA6BF;IAGI,eAAA;ECxBF;AACF;;AD0BA;EACE,iBAAA;ACvBF;ADbE;EAmCF;IAGI,eAAA;ECrBF;AACF;;ADuBA;EACE,kBAAA;ACpBF;ADtBE;EAyCF;IAGI,eAAA;EClBF;AACF;;AAhCA;EACI,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;AAmCJ;ADvCE;ECLF;IAWQ,kBAAA;IACA,YAAA;EAqCN;AACF;ADvCE;ECXF;IAeQ,6CAAA;EAuCN;AACF;AAtCI;EACG,kBAAA;EACA,iBAAA;AAwCP;AApCI;EACI,yDAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,kCAAA;AAsCR;ADhEE;ECkBE;IAUQ,aAAA;IACA,cAAA;EAwCV;AACF","sourcesContent":["//Colors\n$square-dark:rgb(181, 136,99);\n$square-light:rgb(240, 217,181);\n$tablet-breakpoint: 768px;\n$desktop-breakpoint: 1280px;\n@mixin tablet {\n  @media (min-width: $tablet-breakpoint) {\n    @content;\n  }\n}\n\n@mixin desktop {\n  @media (min-width: $desktop-breakpoint) {\n    @content;\n  }\n}\n\n*{\n  box-sizing: border-box;\n}\n//Margins for these pages are consistent, so they're defined here as variables.\n$mobile-indent: 1rem;\n$tablet-indent: 2.25rem;\n\n//This needs to change based on the width of the window.\n//We get the width with 100vw, find how much larger the window is than our desktop breakpoint,\n//then divide it by 2 so that the indent can be applied to both sides.\n$base-desktop-indent: 25rem;\n$desktop-indent: calc(\n  $base-desktop-indent + ((1vw * 100) - $desktop-breakpoint) / 2\n);\n\na {\n  text-decoration: none;\n}\np{\n  font-size: 1rem;\n  @include tablet{\n    font-size: 2rem;\n  }\n}\nh2{\n  font-size: 1.5rem;\n  @include tablet{\n    font-size: 3rem;\n  }\n}\nh3{\n  font-size: 1.25rem;\n  @include tablet{\n    font-size: 2rem;\n  }\n}","@use \"../../styles/partials\" as *;\n.navbar{\n    background-color: $square-light;\n    display:flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    list-style-type: none;\n    margin: 0;\n    height:3rem;\n    padding: 0 $mobile-indent;\n    @include tablet{\n        padding: 0 $tablet-indent;\n        height: 5rem;\n    }\n    @include desktop{\n        padding: 0 $desktop-indent;\n    }\n    &__title{\n       margin-right: auto;\n       margin-left: auto;\n       \n    }\n    \n    &__settings{\n        background-image: url('../../assets/settings.svg');\n        width: 1rem;\n        height:1rem;\n        background-repeat: no-repeat;\n        background-size: cover;\n        border:none;\n        outline: none;\n        background-color: rgba(#000, 0);\n        @include tablet{\n            width: 2.5rem;\n            height: 2.5rem;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
